import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/scrollspy';
import '../styles/page-obituary.scss';
import '../js/vendor/masonry.pkgd.min';
import { loader } from './scripts/loader';
import { debounce } from './scripts/debounce';

const memorialList = {
    debounceInterval: 500,
    loadMoreButton: $('#moreObituary'),
    filters: [],
    init: function (){
        this.loadFilters();
        this.loadList();
        this.initCitySelector();
    },
    loadFilters: function (){
        const wrapper = $('#filter-box');
        const $this = this;

        $.ajax({
            url: '/api/memorials/filter-data/',
            type: 'POST',
            data: [],
            dataType: 'json',
            beforeSend: function () {
                loader.show();
            },
            success: function( result ) {
                loader.hide();
                if (result.success){
                    $this.filters = result.filter;
                    const html = $this.filters.reduce( (acc, elm) => {
                        const filters = elm.items.reduce((facc, filter) => (
                            facc + `
                                <label class="filter-box__label">
                                    <input type="checkbox" class="filter-${elm.type}" value="${filter.value}">
                                    <span class="filter-box__name">${filter.label}</span>
                                    <span class="filter-box__checkmark"></span>
                                    <span class="filter-box__counter">${filter.counter}</span>
                                </label>
                            `
                        ), '');

                        return acc + `
                            <div class="filter-box-item filter-box__${elm.type}">
                                <div class="filter-box__title">${elm.title}</div>
                                <div class="label-box">${filters}</div>
                                <label class="${elm.type}-all more-filter-items show-more ${elm.items.length < 5 ? 'hide-desktop' : ''}">Se fler</label>
                            </div>
                        `;
                    }, '');
                    wrapper.html(html);
                    $this.initFiltersEvents();
                }
            }
        });
    },
    getFilterValues: function (){
        const searchValue = $('#nameInput').val();
        const city = $('#city-dropdown-obituary_cities_drop').val();
        const page = $('#moreObituary').data('page');

        let filter = {
            city: city,
            search: searchValue,
            page: page
        };

        const sideFilterValues = this.filters.reduce((acc, elm) => {
            const section = elm.type;

            // const values = [];
            // $(`.filter-box__${section} input:checkbox:checked`).each(function(){
            //     values.push($(this).val());
            // });

            acc[section] = $(`.filter-box__${section} input:checkbox:checked`).val();
            return acc;
        }, {});

        filter = {...filter, ...sideFilterValues};
        return filter;
    },
    initFiltersEvents: function (){
        const $this = this;
        $(".filter-box__region .filter-box__label").slice(5).addClass("hide-item");
        $(".filter-box__decade .filter-box__label").slice(5).addClass("hide-item");

        $('.more-filter-items').click(function (e){
            const $this = $(this);
            if ($this.hasClass('show-more')){
                $this.html('Visa mindre');
            } else {
                $this.html('Se fler');
            }
            $this.toggleClass("show-more");

            $this.closest('.filter-box-item').find('.filter-box__label').toggleClass("hide-item").toggleClass("show-item");
        });

        $this.loadMoreButton.click(function (){
            if ($(this).hasClass('disabled')){
                return false;
            }

            $this.updateLoadMoreButton();
            $this.loadList(false);
        });

        $('#nameInput').on("keyup", debounce(function (){
            $this.resetLoadMoreButton();
            $this.loadList();
        }, $this.debounceInterval));

        $('#city-dropdown-obituary_cities_drop').on('change', function (){
            $this.resetLoadMoreButton();
            $this.loadList()
        });

        $('.filter-column__list :checkbox').change(function (e){
            const is_checked = $(this).is(':checked');
            $(this).closest('.filter-box-item').find(':checkbox').prop('checked', false);
            $(this).prop('checked', is_checked);
            $this.resetLoadMoreButton();
            $this.loadList();
        });
    },
    loadList: function (newSearch = true){
        const $this = this;
        const wrapper = $('#result-list');

        if (newSearch === true){
            $this.resetLoadMoreButton();
        }
        const filter = this.getFilterValues();
	    const today = new Date();
	    const pad = n => String(n).padStart(2, '0');
	    const todayStr = `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`;

        $.ajax({
            url: '/api/memorials/',
            type: 'POST',
            data: filter,
            dataType: 'json',
            beforeSend: function () {
                loader.show();
            },
            success: function( result ) {
                loader.hide();
                if (result.success){
                    const list = result.list;
	                const html = list.reduce((acc, item) => {
                        const itemLocation = (item.location || '').trim();
                        const itemFuneralDate = (item.funeralDate || '').trim();
                        const itemFuneralTime = (item.funeralTime || '').trim();
                        const hasCeremony = itemLocation !== '' && itemFuneralDate !== '' && itemFuneralTime !== '' && itemFuneralDate >= todayStr;
                        return acc + `
                            <div class="filter-column__person">
                                <a href="${item.url.replace(/&quot;-/g,'')}">
                                    <div class="filter-person d-flex flex-column">
                                        <div class="filter-person__bg" style="background-image: url('${item.bg}');"></div>
                                        <div class="person-info d-flex flex-column flex-grow-1 justify-content-between">
                                            <div class="person-info__body">
                                                ${ item.fund && item.fund.image ? `
                                                    <div class="filter-person__badge">
                                                        <div class="filter-person__fund"><img src="${item.fund.image}" alt="${item.fund.title}"/></div>
                                                    </div>
                                                ` : '' }
                                                <div class="filter-person__foto"><img src="${item.photo}" alt="${item.name}" /></div>
                                                <div class="filter-person__name">${item.name}</div>
                                                ${ item.deceasedDate ? `<div class="filter-person__date">${item.deceasedDate}</div>` : ''}
                                                ${ hasCeremony ? `<div class="filter-person__location"><div class="icon" data-toggle="obituary-tooltip" title="Ceremonilokal"></div><div>${itemLocation}</div></div>` : ''}
                                                ${ hasCeremony ? `<div class="filter-person__time"><div class="icon" data-toggle="obituary-tooltip" title="Ceremonidatum"></div><div>${itemFuneralDate} ${itemFuneralTime}</div></div>` : ''}
                                                ${ item.greetings ? `<div class="filter-person__greetings"><div class="icon" data-toggle="obituary-tooltip" title="Antal hälsningar"></div><div>${item.greetings} ${item.greetings == 1 ? 'hälsning' : 'hälsningar'}</div></div>` : ''}
                                            </div>
                                            <div class="filter-person__button">
                                                <div class="filter-person__link">
                                                    <button class="btn btn-blue obituary-link">Läs minnesord</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        `
                    }, '')
                    if (newSearch === true){
                        wrapper.html(html);
                    } else {
                        wrapper.append(html);
                    }

                    $this.initTooltips();

                    if (!result.nextPage){
                        $this.disableLoadMoreButton();
                    }
                }
            }
        });
    },
    disableLoadMoreButton: function (){
        this.loadMoreButton.addClass('disabled');
    },
    updateLoadMoreButton: function (){
        const page = parseInt(this.loadMoreButton.data('page'), 10);
        this.loadMoreButton.data('page', page + 1);
    },
    resetLoadMoreButton: function (){
        this.loadMoreButton.data('page', 1).removeClass('disabled');
    },
    initCitySelector: function (){
        const choice = new Choices('#city-dropdown-obituary_cities_drop', {
            placeholder: true,
            silent: true,
            searchPlaceholderValue: '',
            itemSelectText: '',
            noResultsText: $('.obituary-cities').data('no-results'),
            shouldSort: false,
            position: "bottom",
            searchResultLimit: 100,
            searchFields: ['label'],
            fuseOptions: {
                includeMatches: true,
                threshold: 0.0,
                tokenize: true,
            },
            classNames: {
                containerOuter: 'choices cities-list--choices',
            }
        });

        const selector = document.getElementById('city-dropdown-obituary_cities_drop');

        choice._onEnterKey = function (event) {
            const searchValue = event.target.value;

            choice.setValue([{ value: searchValue, label: searchValue }]);
            choice.setChoiceByValue(searchValue);
            choice.hideDropdown();

            selector.dispatchEvent(new Event('change'));

            return true;
        }
    },
    initTooltips: function (){
        $('.person-info__body > div')
            .on( "mouseenter", function() {
                $(this).find('.icon').tooltip({
                    template: '<div class="tooltip obituary-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>',
                    offset: '0,2px'
                }).tooltip('show');
            })
            .on( "mouseleave", function() {
                $(this).find('.icon').tooltip('hide');
            });
    }
}

$(document).ready(function () {
    memorialList.init();
});
